<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import mdiChevronRight from '~icons/mdi/chevron-right'
import { useNavigation } from '@/composables/useNavigation'
import type { NavigationMenuItem } from './types'

const { t } = useI18n()
const { getMenuItemTo } = useNavigation()

defineProps<{
  items: NavigationMenuItem[]
}>()

function getChildren(item: NavigationMenuItem) {
  return item.list_menu?.length ? item.list_menu : (item.sub_menu ?? [])
}
</script>

<template>
  <v-list
    nav
    density="compact"
    class="bg-grey-darkest pa-0"
  >
    <template
      v-for="sub in items"
      :key="sub.locale_name"
    >
      <v-menu
        v-if="getChildren(sub).length"
        open-on-hover
        :open-delay="100"
        :close-delay="100"
        location="end"
        transition="slide-x-transition"
      >
        <template #activator="{ props: menuProps }">
          <v-list-item
            v-bind="menuProps"
            :title="t(sub.locale_name)"
            :append-icon="mdiChevronRight"
            class="text-body-medium text-capitalize"
          />
        </template>

        <v-list
          nav
          density="compact"
          class="bg-grey-darkest pa-0"
        >
          <v-list-item
            v-for="child in getChildren(sub)"
            :key="child.locale_name"
            :title="t(child.locale_name)"
            :to="getMenuItemTo(child)"
            class="text-body-medium"
          />
        </v-list>
      </v-menu>

      <v-list-item
        v-else
        :title="t(sub.locale_name)"
        :to="getMenuItemTo(sub)"
        class="text-body-medium text-capitalize"
      />
    </template>
  </v-list>
</template>
